import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getUnreadCount } from '@/api/notifications';

const POLL_INTERVAL_MS = 30_000;

export const useNotificationsStore = defineStore('notifications', () => {
  const unreadCount = ref(0);
  let timer: ReturnType<typeof setInterval> | null = null;

  async function refresh() {
    try {
      unreadCount.value = await getUnreadCount();
    } catch {
      // Silent — auth errors handled by axios interceptor, others irrelevant for a badge
    }
  }

  function startPolling() {
    if (timer) return;
    refresh();
    timer = setInterval(refresh, POLL_INTERVAL_MS);
  }

  function stopPolling() {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  }

  function reset() {
    stopPolling();
    unreadCount.value = 0;
  }

  return { unreadCount, refresh, startPolling, stopPolling, reset };
});
